module.exports = __webpack_public_path__ + "img/app/home/img/icon-down-hover.865d0f1bae88974aa4036e623ed9d5aa.png";